// extracted by mini-css-extract-plugin
export default {"root":"AppSidebarSkeleton_root__LTtho","sider":"AppSidebarSkeleton_sider__EpDat"};